module.exports = __webpack_public_path__ + "static/home21-3177bbb55c00960c60213137876c0246.png";